import moment from "moment-timezone";
import React from "react";
import Modal from "react-modal";
import { useRecoilState } from "recoil";
import styled from "styled-components";
import { Coupons } from "../../controller/StoreController";
import { langState, langText } from "../../recoil/lang";
import "../../styles/CustomModal.css";

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
  coupons: Coupons[];
  modalType: string;
};

const CouponListModal = ({
  isVisible,
  setVisible,
  coupons,
  modalType,
}: Props) => {
  const onCloseModal = () => {
    setVisible(false);
  };

  const [lang, setLang] = useRecoilState<number>(langState);

  return (
    <Modal
      isOpen={isVisible}
      onRequestClose={onCloseModal}
      className="couponListModal modal-content bottom"
      closeTimeoutMS={100}
      ariaHideApp={false}
    >
      <Style>
        <div className="couponListModalWrap">
          <h2>{langText.coupon_modal_title[lang]}</h2>
          <h3>{langText.coupon_modal_sub_title[lang]}</h3>
          <img
            className="closeIcon"
            onClick={onCloseModal}
            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
            alt="ic"
          />
          <div className="couponListWrap">
            {coupons &&
              coupons.map((data, index) => (
                <div
                  key={index}
                  className={`couponListContent ${
                    modalType === "main" && "mainColor"
                  }`}
                >
                  {data.coupon_type === 0 ? (
                    <h1>{data.price.toLocaleString()}원</h1>
                  ) : (
                    <h1>{data.percent}%</h1>
                  )}
                  <div>
                    <p>{data.coupon_name}</p>
                    <p>
                      {data.requirement.toLocaleString()}원
                      {langText.min_price_notice[lang]}
                    </p>
                    {data.coupon_type === 1 && (
                      <p>
                        {langText.optionModal_title_Maximum[lang]}{" "}
                        {data.max_discount.toLocaleString()}원{" "}
                        {langText.discount[lang]}
                      </p>
                    )}
                    {modalType === "main" && (
                      <p>
                        {langText.addCardModal_expired_date[lang]} :
                        {data.end_date &&
                          moment(data.end_date).format("YYYY-MM-DD HH:mm:ss")}
                      </p>
                    )}
                  </div>
                </div>
              ))}
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default CouponListModal;

const Style = styled.div`
  * {
    color: #fff;
  }
  h2 {
    font-size: 32px;
    font-weight: 700;
  }
  h3 {
    margin: 40px 0;
    padding: 0 40px;
    font-size: 18px;
    font-weight: 400;
  }

  /* couponListModalWrap */
  .couponListModalWrap {
    height: 100dvh;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  .closeIcon {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 40px;
  }

  /* couponListWrap */
  .couponListWrap {
    max-height: 800px;
    overflow-y: auto;
  }
  /* couponListContent */
  .couponListContent {
    width: 85vw;
    margin-bottom: 20px;
    padding: 42px 55px;
    text-align: left;
    border-radius: 20px;
    background: #ffb800;

    h1 {
      padding-bottom: 18px;
      font-size: 40px;
      font-weight: 700;
    }
    p {
      margin-top: 10px;
      margin-bottom: 0px;
      font-size: 18px;
      font-weight: 400;
    }
  }
  .couponListContent.mainColor {
    background: #4dd2ae;
  }

  @media (max-width: 700px) {
    h2 {
      font-size: 18px;
    }
    h3 {
      margin: 20px 0;
      padding: 0;
      font-size: 12px;
    }
    .closeIcon {
      width: 24px;
      right: 12px;
      top: 12px;
    }
    .couponListModalWrap {
      height: auto;
      min-height: 40dvh;
      padding: 0 10px;
      padding-top: 40px;
      border-radius: 5px 5px 0 0;
      justify-content: flex-start;
    }
    .couponListWrap {
      width: 100%;
      max-height: 60dvh;
    }
    .couponListContent {
      display: flex;
      align-items: center;
      gap: 16px;
      width: 100%;
      margin-bottom: 12px;
      padding: 20px;
      border-radius: 10px;
      background: #ffb800;

      h1 {
        font-size: 28px;
        padding: 0;
        white-space: nowrap;
      }
      p {
        margin: 0;
        font-size: 12px;
        line-height: 16px;
      }
    }
  }
`;
